import { Typography } from "@circleco/compass/components/Typography";

import { classNames } from "@/react/helpers/twMergeWithCN";

export const ChatRoomDescription = ({
  description,
  className = "",
}: {
  description: string;
  className?: string;
}) => {
  if (!description) return null;
  return (
    <div className={classNames("px-5 pt-4 whitespace-pre-line", className)}>
      <Typography variant="body-sm">{description}</Typography>
    </div>
  );
};
